import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Vertical stack variant for list-view results.
 */
@Component({
  selector: 'vh-result-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content />`,
  styleUrl: './result-list.component.scss',
})
export class VhResultListComponent {}
